import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../styles/HptScreens.css';
import SignaturePad from './SignaturePad';
import imagenFondo from '../assets/logo_elecnor.jpg';
import html2pdf from 'html2pdf.js';

const API_URL = process.env.REACT_APP_API_URL;

const PermisoPlataforma = ({ datosPrevios, onSave, onCancel, readOnly = false, usuarioActual, isPdfMode = false }) => {
    
    const { id } = useParams();
    const navigate = useNavigate();
    const isStandalone = typeof onSave !== 'function' && !isPdfMode;
    const pdfRef = useRef();
    const [isPrintingLocal, setIsPrintingLocal] = useState(false);

    const itemsChecklist = [
        { key: "manual_inst", label: "Se encuentra a tu disposicion el manual de instrucciones de la maquina" },
        { key: "llantas_aros", label: "Las llantas y los aros de acero de las ruedas están correctos" },
        { key: "motor_cables", label: "Estado compartimento motor, mangueras, cables, correas, etc. están correctos" },
        { key: "bateria_conex", label: "Estado de la batería: ausencia de derrames, apriete de conexiones, cables, etc, están correctos" },
        { key: "sistema_hidr", label: "Sistema hidráulico, mangueras y manguitos, cilindros hidráulicos, están correctos" },
        { key: "fluidos_niv", label: "Aceite de motor, líquido refrigerante, combustible: Ausencia de goteos y niveles correctos" },
        { key: "contrapeso_perno", label: "Contrapeso y perno correctos" },
        { key: "cubiertas_mandos", label: "Cubiertas de mandos correctas" },
        { key: "barandillas_puerta", label: "Barandillas de seguridad, puerta de acceso, piso, anclajes, están correctos" },
        { key: "brazos_elev", label: "Estado correcto de los brazos de elevación" },
        { key: "placa_datos", label: "Placa de datos, limitaciones de movimientos, diagramas de capacidad de carga, señales de arventencia, peligros, uso de epi's etc, correctos" },
        { key: "ctrl_brazo", label: "Funcionamiento de Controles de: Brazo de elevacion - Levantar/bajar/extender/retraer" },
        { key: "ctrl_rotacion", label: "Funcionamiento de Controles de: Rotación" },
        { key: "ctrl_marcha", label: "Funcionamiento de Controles de: Marcha hacia delante y atrás" },
        { key: "ctrl_desplaz", label: "Funcionamiento de Controles de: Desplazamiento izquierda y derecha" },
        { key: "ctrl_estabiliz", label: "Funcionamiento de Controles de: Extensión y retraimiento de estabilizadores" },
        { key: "ctrl_freno", label: "Funcionamiento de Controles de: Freno y retención" },
        { key: "ctrl_encendido", label: "Encendido y funcionamiento correcto del equipo, frenos, alarmas acústicas, etc." },
        { key: "ctrl_funcionam", label: "Funcionamiento correcto del brazo" },
        { key: "epis_necesarios", label: "Se dispone de los EPI'S necesarios (arnés de seguridad + sistema de amarre)" }
    ];

    const rastroEstadoInicial = {
        fechaInspeccion: new Date().toISOString().split('T')[0],
        horaInspeccion: new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }),
        numeroSerie: '', 
        ordenTrabajo: '', 
        responsable: '', 
        tipoMaquinaria: '',
        observaciones: '',
        firmaJefeTurno: null, 
        firmaJefeTrabajo: null, 
        firmaRecursoPreventivo: null
    };

    itemsChecklist.forEach(item => {
        rastroEstadoInicial[item.key] = ''; 
    });

    const [formData, setFormData] = useState(datosPrevios || rastroEstadoInicial);
    const [firmaActiva, setFirmaActiva] = useState(null);

    useEffect(() => {
        if (isStandalone && id) {
            const cargarDatos = async () => {
                try {
                    const token = localStorage.getItem('userToken');
                    const res = await axios.get(`${API_URL}/api/hpt/plataforma/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    
                    const dbData = res.data;
                    setFormData({
                        fechaInspeccion: dbData.fecha_inspeccion || "",
                        horaInspeccion: dbData.hora_inspeccion || "",
                        numeroSerie: dbData.numero_serie || "",
                        ordenTrabajo: dbData.orden_trabajo || "",
                        responsable: dbData.responsable || "",
                        tipoMaquinaria: dbData.tipoMaquinaria || "",
                        observaciones: dbData.observaciones || "",
                        manual_inst: dbData.check_manual_inst || "",
                        llantas_aros: dbData.check_llantas_aros || "",
                        motor_cables: dbData.check_motor_cables || "",
                        bateria_conex: dbData.check_bateria_conex || "",
                        sistema_hidr: dbData.check_sistema_hidr || "",
                        fluidos_niv: dbData.check_fluidos_niv || "",
                        contrapeso_perno: dbData.check_contrapeso_perno || "",
                        cubiertas_mandos: dbData.check_cubiertas_mandos || "",
                        barandillas_puerta: dbData.check_barandillas_puerta || "",
                        brazos_elev: dbData.check_brazos_elev || "",
                        placa_datos: dbData.check_placa_datos || "",
                        ctrl_brazo: dbData.check_ctrl_brazo || "",
                        ctrl_rotacion: dbData.check_ctrl_rotacion || "",
                        ctrl_marcha: dbData.check_ctrl_marcha || "",
                        ctrl_desplaz: dbData.check_ctrl_desplaz || "",
                        ctrl_estabiliz: dbData.check_ctrl_estabiliz || "",
                        ctrl_freno: dbData.check_ctrl_freno || "",
                        ctrl_encendido: dbData.check_ctrl_encendido || "",
                        ctrl_funcionam: dbData.check_ctrl_funcionam || "",
                        epis_necesarios: dbData.check_epis_necesarios || "",
                        firmaJefeTurno: dbData.firma_jefe_turno ? JSON.parse(dbData.firma_jefe_turno) : null,
                        firmaJefeTrabajo: dbData.firma_jefe_trabajo ? JSON.parse(dbData.firma_jefe_trabajo) : null,
                        firmaRecursoPreventivo: dbData.firma_recurso_preventivo ? JSON.parse(dbData.firma_recurso_preventivo) : null
                    });
                } catch (error) {
                    Swal.fire('Error', 'No se pudo cargar el documento', 'error');
                }
            };
            cargarDatos();
        }
    }, [id, isStandalone]);

    const handleGuardarDirecto = async () => {
        try {
            const token = localStorage.getItem('userToken');
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const payload = { ...formData, id_hpt: null };

            if (id) {
                await axios.put(`${API_URL}/api/hpt/plataforma/${id}`, payload, config);
                Swal.fire({
                    title: "¡Actualizado!", text: `Registro actualizado correctamente`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }else{
                const res = await axios.post(`${API_URL}/api/hpt/plataforma`, payload, config);

                Swal.fire({
                    title: "¡Guardado!", text: `Registrado con ID: ${res.data.id_registro}`, icon: "success",
                    confirmButtonColor: '#003366', timer: 2500
                });
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudo guardar en el servidor.', 'error');
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleGuardarFirma = (base64) => {
        const fechaHora = new Date().toLocaleString('es-ES');
        let nombreCompleto = usuarioActual;
        if (!nombreCompleto) {
            const token = localStorage.getItem('userToken');
            if (token) {
                const dec = JSON.parse(atob(token.split('.')[1]));
                nombreCompleto = `${dec.nombre || ''} ${dec.apellidos || ''}`.trim() || dec.user;
            } else {
                nombreCompleto = 'Usuario Desconocido';
            }
        }

        setFormData({
            ...formData,
            [firmaActiva]: { base64: base64, nombre: nombreCompleto, fechaHora: fechaHora }
        });
        setFirmaActiva(null);
    };

    const tieneRespuestasNegativas = itemsChecklist.some(item => formData[item.key] === 'NO');

    const renderCajaFirma = (label, fieldKey) => {
        const firma = formData[fieldKey];
        return (
            <div className="spe-sign-line">
                <span style={{ fontWeight: 'bold', fontSize: '12px', marginBottom: '5px', color: '#003366' }}>{label}:</span>
                {firma ? (
                    <div style={{ backgroundColor: '#fff', padding: '5px', borderRadius: '4px', border: '1px solid #ddd', width: '100%', boxSizing: 'border-box' }}>
                        <img src={firma.base64} alt="Firma" style={{ height: '35px', display: 'block', marginBottom: '5px' }} />
                        <div style={{ fontSize: '9px', color: '#555', lineHeight: '1.2' }}>
                            <strong>Por:</strong> {firma.nombre} <br/>
                            <strong>Fecha:</strong> {firma.fechaHora}
                        </div>
                    </div>
                ) : (
                    !readOnly && (
                        <button type="button" className="btn-save" style={{ width: 'fit-content', padding: '4px 10px', fontSize: '11px', backgroundColor: '#003366', marginTop: 'auto' }} onClick={() => setFirmaActiva(fieldKey)}>
                            ✍️ Firmar
                        </button>
                    )
                )}
            </div>
        );
    };

    const handleDescargarPDF = () => {
        setIsPrintingLocal(true);
        Swal.fire({ title: 'Generando documento...', text: 'Por favor espera', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        setTimeout(() => {
            const element = pdfRef.current;
            const opt = {
                margin:       [10, 5, 10, 5],
                filename:     `Permiso_${new Date().getTime()}.pdf`,
                image:        { type: 'jpeg', quality: 0.98 },
                html2canvas:  { scale: 2, useCORS: true, windowWidth: 720 },
                jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
                pagebreak:    { mode: ['css', 'legacy'] }
            };
            html2pdf().set(opt).from(element).save().then(() => {
                setIsPrintingLocal(false);
                Swal.close();
            });
        }, 800);
    };

    const contenidoFormulario = (
        <div className={`pe-container ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}>
            <div ref={pdfRef}
                className={`pe-container ${isPdfMode || isPrintingLocal ? 'pe-pdf-mode' : 'pe-modal-content'}`}
                style={isPrintingLocal ? { width: '720px', maxWidth: '720px', margin: '0 auto', backgroundColor: '#fff', transform: 'none' } : {}}

            >
                <header className="spe-header">
                    <div className="spe-logo"><img src={imagenFondo} alt="Logo" style={{ maxHeight: '40px' }} /></div>
                    <div className="spe-title-box">
                        <h2 className="spe-main-title">COMPROBACIÓN DE SEGURIDAD PLATAFORMA ELEVADORA</h2>
                    </div>
                    <div className="spe-code">
                        <span className="info-label">Identificación del Equipo:</span>
                        <input type="text" name="numeroSerie" value={formData.numeroSerie} onChange={handleChange} disabled={readOnly} className="spe-input-id" placeholder="PEMP-01" />
                    </div>
                </header>

                <section className="spe-section">
                    <h3 className="spe-section-title">0. Fecha y Planificación</h3>
                    <div className="spe-dat_sol-2">
                        <div className="spe-input-group">
                            <span className="info-label">FECHA:</span>
                            <input type="date" name="fechaInspeccion" value={formData.fechaInspeccion} onChange={handleChange} disabled={readOnly} className="spe-input" />
                        </div>
                        <div className="spe-input-group">
                            <span className="info-label">HORA:</span>
                            <input type="text" name="horaInspeccion" value={formData.horaInspeccion} onChange={handleChange} disabled={readOnly} className="spe-input" />
                        </div>
                        <div className="spe-input-group">
                            <span className="info-label">Nº PERMISO / ORDEN DE TRABAJO:</span>
                            <input type="text" name="ordenTrabajo" value={formData.ordenTrabajo} onChange={handleChange} disabled={readOnly} className="spe-input" />
                        </div>
                    </div>
                </section>
                
                <section className="spe-section">
                    <h3 className="spe-section-title">1. COMPROBACIONES PREVIAS AL INICIO DE LOS TRABAJOS</h3>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', backgroundColor: '#eee', padding: '1px' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 15mm 15mm 15mm', backgroundColor: '#003366', color: '#fff', padding: '6px 10px', fontSize: '11px', fontWeight: 'bold', textAlign: 'center', alignItems: 'center' }}>
                            <div style={{ textAlign: 'left' }}>Puntos de Comprobación Requeridos</div>
                            <div>SI</div>
                            <div>NO</div>
                            <div>N/A</div>
                        </div>

                        {itemsChecklist.map((item, index) => (
                            <div key={item.key} style={{ display: 'grid', gridTemplateColumns: '1fr 15mm 15mm 15mm', backgroundColor: index % 2 === 0 ? '#fff' : '#f5f7fa', padding: '6px 10px', fontSize: '11px', alignItems: 'center', minHeight: '32px' }}>
                                <div style={{ paddingRight: '10px', color: '#333' }}>{index + 1}. {item.label}</div>
                                <div style={{ textAlign: 'center' }}>
                                    <input type="radio" name={item.key} value="SI" checked={formData[item.key] === 'SI'} onChange={handleChange} disabled={readOnly} />
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <input type="radio" name={item.key} value="NO" checked={formData[item.key] === 'NO'} onChange={handleChange} disabled={readOnly} />
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <input type="radio" name={item.key} value="NA" checked={formData[item.key] === 'NA'} onChange={handleChange} disabled={readOnly} />
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="spe-section">
                    <h3 className="spe-section-title">2. OBSERVACIONES</h3>
                    <div style={{ padding: '8px' }}>
                        <textarea name="observaciones" rows="2" value={formData.observaciones || ''} onChange={handleChange} disabled={readOnly} className="main-textarea" style={{ width: '100%', boxSizing: 'border-box', fontSize: '12px' }} placeholder="Escribe aquí anotaciones sobre la plataforma..." />
                    </div>
                </section>

                <div className={`spe-alert ${tieneRespuestasNegativas ? 'spe-alert-danger' : ''}`} style={{ transition: 'all 0.3s ease' }}>
                    ⚠️ ATENCIÓN, si has contestado que NO a algunas de estas preguntas, NO PUEDES REALIZAR EL TRABAJO hasta solucionar este punto.
                </div>

                <section className="spe-section">
                    <h3 className="spe-section-title">3. FIRMAS DE AUTORIZACIÓN Y SEGUIMIENTO</h3>
                    <div className="spe-signature-box" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                        {renderCajaFirma('Jefe de Turno', 'firmaJefeTurno')}
                        {renderCajaFirma('Jefe de Trabajo', 'firmaJefeTrabajo')}
                        {renderCajaFirma('Recurso Preventivo', 'firmaRecursoPreventivo')}
                    </div>
                </section>

                <footer className="spe-footer-note">
                    <div className='spe-footer-line'></div>
                    Archivar formato original en almacén y adjuntar copia en cierre de OT o PTW.
                </footer>
            </div>

            {!isPdfMode && (
                <div className="spe-modal-actions">
                    <button type="button" className="btn-close" onClick={() => isStandalone ? navigate('/dashboard') : onCancel()}>
                        {readOnly ? '❌ Cerrar' : '❌ Cancelar'}
                    </button>
                    <button type="button" className="btn-print" onClick={handleDescargarPDF} style={{ backgroundColor: '#0288d1', color: '#fff', padding: '6px 15px', fontWeight: 'bold' }}>
                        🖨️ Imprimir Hoja
                    </button>
                    {!readOnly && (
                        <button type="button" className="btn-save" style={{ backgroundColor: '#2e7d32' }} onClick={() => isStandalone ? handleGuardarDirecto() : onSave(formData)}>
                            💾 Guardar Anexo
                        </button>
                    )}
                </div>
            )}

            {firmaActiva && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 100000 }}>
                    <SignaturePad onSave={handleGuardarFirma} onCancel={() => setFirmaActiva(null)} />
                </div>
            )}
        </div>
    );

    if (isPdfMode) return contenidoFormulario;

    return (
        <div className={isStandalone ? "container" : "spe-modal-overlay"}>
            {contenidoFormulario}
        </div>
    );
};

export default PermisoPlataforma;